class UpdateReferralCodeReq {
  constructor() {
    this.customerId = null;
    this.referralCode = null;
  }
}
// module.exports = UpdateReferralCodeReq;
export default UpdateReferralCodeReq;